import { FactoryProvider } from '@angular/core';
import { hybridHelper } from './hybrid-helper';

// NOTE: This does not work with AOT ("function expressions are not supported in decorators")
/**
 * Global list of providers to add to list of providers on top component (AppComponent).
 * This defines providers with mappings between angularJS name and Angular name.
 * The providers are then used by UpgradedProviderService
 */
export class UpgradedProviders {
    public static providers: Array<FactoryProvider> = [
        hybridHelper.buildProviderForUpgrade('userProfile', 'userProfile'),
        hybridHelper.buildProviderForUpgrade('userSettings', 'userSettings'),
        hybridHelper.buildProviderForUpgrade('accountService', 'accountService')
    ];
}
